   
   export function computeQueryWeights(codebook: Float32Array, queryVector: Float32Array): Float32Array {
    const rows = 64;
    const cols = 512;
    if (codebook.length !== rows * cols) {
        throw new Error(`Codebook length mismatch: expected ${rows * cols}, got ${codebook.length}`);
    }
    if (queryVector.length !== cols) {
        throw new Error(`Query vector length mismatch: expected ${cols}, got ${queryVector.length}`);
    }
    // L2 normalize query (defensive; exporter may or may not have normalized)
    const q = new Float32Array(queryVector);
    {
        let n2 = 0;
        for (let i = 0; i < q.length; i++) n2 += q[i] * q[i];
        const inv = n2 > 1e-12 ? 1.0 / Math.sqrt(n2) : 1.0;
        for (let i = 0; i < q.length; i++) q[i] *= inv;
    }

    const out = new Float32Array(rows);
    for (let r = 0; r < rows; r++) {
        let sum = 0;
        const rowBase = r * cols;
        for (let c = 0; c < cols; c++) {
            sum += codebook[rowBase + c] * q[c];
        }
        out[r] = sum;
    }
    return out;
}

export function computeGramMatrix(codebook: Float32Array): Float32Array {
    const rows = 64;
    const cols = 512;
    if (codebook.length !== rows * cols) {
        throw new Error(`Codebook length mismatch: expected ${rows * cols}, got ${codebook.length}`);
    }
    const gram = new Float32Array(rows * rows);
    for (let i = 0; i < rows; i++) {
        const iBase = i * cols;
        for (let j = i; j < rows; j++) {
            const jBase = j * cols;
            let sum = 0;
            for (let k = 0; k < cols; k++) {
                sum += codebook[iBase + k] * codebook[jBase + k];
            }
            gram[i * rows + j] = sum;
            gram[j * rows + i] = sum;
        }
    }
    return gram;
}